import { OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

import { AuthInterceptor } from 'src/app/core/interceptors/http-interceptor';

import { LsHelperService } from './ls-helper.service';
import { MultiLanguageService } from './multi-language.service';
import { AppInjector } from 'src/app/core/services/app-injector.service';

export class Basei18n implements OnInit, OnDestroy{
	currentLanguage = new Subject();
	langKey: any = 'SELECTED_LANGUAGE';
	lang: any;

	protected ls: LsHelperService;
	protected translate: TranslateService;
	protected ml: MultiLanguageService;

	languageChangeEventSubs: any;

	constructor(
	) {
		this.ls = AppInjector.injector.get(LsHelperService);
		this.translate = AppInjector.injector.get(TranslateService); 
		this.ml = AppInjector.injector.get(MultiLanguageService);

		this.lang = this.ls.get(this.langKey);

        if(this.lang == null){        	
        	this.lang = "es";
            this.translate.setDefaultLang(this.lang);
            this.ls.set(this.langKey, this.lang);

            this.ml.trigger()         
        }

		this.translate.addLangs(['en', 'es']);
		//this.translate.setDefaultLang('es');		

		//this.translate.use('es');		

		this.languageChangeEventSubs = this.ml.languageChangeEvent.subscribe(
			(language:any) => {
				this.translate.use(language)
			}
		);		
	}	

	ngOnInit(): void {

	}	

	ngOnDestroy(): void {
		this.languageChangeEventSubs.unsubscribe();
	}		

	setLanguage(lng) {
		this.translate.use(lng);
		this.ls.set(this.langKey, lng);
	}	

	refreshLanguage(){
		this.translate.use(this.lang)
		this.setLanguage(this.lang);			
	}
}